module.exports = __webpack_public_path__ + "static/media/BELogo-small-white.5623f834.png";